import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {
  ActionResult,
  ActionResultList, ImportConfirmation,
  PagedFilter, RegistrationFilter, RaceRegistration, StatementFileImport,
  StatementImport, StatementImportFilter,
  StatementImportItem,
} from "@model";
import {Observable, map} from "rxjs";
import {EnvironmentService} from "./environment.service";

@Injectable({ providedIn:'root' })
export class AccountStatementsService {

  constructor(private http: HttpClient, private environmentService:EnvironmentService) {
  }

  findImports(filter: PagedFilter<StatementImportFilter> | undefined): Observable<StatementImport[]> {
    return this.http.post<ActionResultList<StatementImport[], number>>(this.environmentService.getApiUrl() + "/api/bank-trasfer/import", filter).pipe(
      map((actionResult: ActionResultList<StatementImport[], number>) => {
        if (actionResult.resultCode !== -1 && actionResult.result) {
          return actionResult.result;
        } else {
          return [];
        }
      }));
  }

  findImportItems(importId: number): Observable<StatementImportItem[]> {
    return this.http.get<ActionResultList<StatementImportItem[], number>>(this.environmentService.getApiUrl() + "/api/bank-trasfer/import/" + importId).pipe(
      map((actionResult: ActionResultList<StatementImportItem[], number>) => {
        if (actionResult.resultCode !== -1 && actionResult.result) {
          return actionResult.result;
        } else {
          return [];
        }
      }));
  }

  uploadSignedStatementFileImport(fileImport: StatementFileImport, onSuccess: () => void, onError: () => void): void {
    this.http.post<ActionResult<boolean>>
    (this.environmentService.getApiUrl() + "/api/bank-trasfer/xml/signed", fileImport)
      .subscribe((actionResult: ActionResult<boolean>): void => {
        if (actionResult.resultCode !== -1) {
          onSuccess()
        } else {
          onError();
        }
      });
  }

  uploadStatementFileImport(fileImport: StatementFileImport, onSuccess: () => void, onError: () => void): void {
    this.http.post<ActionResult<boolean>>
    (this.environmentService.getApiUrl() + "/api/bank-trasfer/xml/raw", fileImport)
      .subscribe((actionResult: ActionResult<boolean>): void => {
        if (actionResult.resultCode !== -1) {
          onSuccess()
        } else {
          onError();
        }
      });
  }

  confirmImport(importConfirmation: ImportConfirmation, onSuccess: (statementImport: StatementImport) => void, onError: () => void): void {
    this.http.post<ActionResult<StatementImport>>
    (this.environmentService.getApiUrl() + "/api/bank-trasfer/import/confirm", importConfirmation)
      .subscribe((actionResult: ActionResult<StatementImport>): void => {
        if (actionResult.resultCode !== -1 && actionResult.result) {
          onSuccess(actionResult.result);
        } else {
          onError();
        }
      });
  }

  deleteImport(importConfirmation: ImportConfirmation, onSuccess: () => void, onError: () => void): void {
    this.http.post<ActionResult<StatementImport>>
    (this.environmentService.getApiUrl() + "/api/bank-trasfer/import/delete", importConfirmation)
      .subscribe((actionResult: ActionResult<StatementImport>): void => {
        if (actionResult.success) {
          onSuccess();
        } else {
          onError();
        }
      });
  }

  findMatchingRegistrations(filter: PagedFilter<RegistrationFilter> | undefined): Observable<RaceRegistration[]> {
    return this.http.post<ActionResultList<RaceRegistration[], number>>(this.environmentService.getApiUrl() + "/api/bank-trasfer/registrations", filter).pipe(
      map((actionResult: ActionResultList<RaceRegistration[], number>) => {
        if (actionResult.resultCode !== -1 && actionResult.result) {
          return actionResult.result;
        } else {
          return [];
        }
      }));
  }

  connectImportAndRegistration(items: StatementImportItem[], onSuccess: () => void): void {
    this.http.post<void>
    (this.environmentService.getApiUrl() + "/api/bank-trasfer/connect", items)
      .subscribe((): void => {
        onSuccess();
      });
  }
}
